import api from 'api'
import { AssessmentRequirement, Evaluation, Interview } from './typings'

type GetAssessmentsByShiftIdRequest = {
  shiftId: number
}

type GetAssessmentsByShiftIdResponse = {
  workerRequirements: AssessmentRequirement[]
  assessments: {
    workerId: number
    interview: Interview
    evaluations: Evaluation[]
    evaluationNote?: string | null
  }[]
}

export const getAssessmentsByShiftId = async ({
  shiftId,
}: GetAssessmentsByShiftIdRequest) => {
  const response = await api.get<GetAssessmentsByShiftIdResponse>(
    `/admin/shift/${shiftId}/assessments`
  )
  return response.data
}
